import { ReactComponent as NavIconDashboard } from '../assets/images/nav-icon-dashboard.svg';
import { ReactComponent as NavIconInvoicing } from '../assets/images/nav-icon-invoicing.svg';
import { ReactComponent as NavIconReporting } from '../assets/images/nav-icon-reporting.svg';
import { ReactComponent as NavIconMatters } from '../assets/images/nav-icon-matters.svg';
import { ReactComponent as NavIconDocuments } from '../assets/images/nav-icon-documents.svg';
import { ReactComponent as NavIconPeople } from '../assets/images/nav-icon-people.svg';
import { ReactComponent as NavIconKnowledgeBase } from '../assets/images/nav-icon-knowledgebase.svg';
import { ReactComponent as AdherenceReminder } from '../assets/images/adherence-reminder.svg';
import { ReactComponent as WalmartSpark } from '../assets/images/Walmart Spark.svg';
import { ReactComponent as ChecklistTask } from '../assets/images/icon _ checklist task.svg';
import { ReactComponent as Link } from '../assets/images/link.svg';
import { ReactComponent as Send } from '../assets/images/send.svg';
import { ReactComponent as GlassSearch } from '../assets/images/GlassSearch.svg';
import { ReactComponent as CopyLink } from '../assets/images/CopyLink.svg';
import { ReactComponent as Info } from '../assets/images/Info.svg';
import { ReactComponent as Folder } from '../assets/images/Folder.svg';
import { ReactComponent as StarFilled } from '../assets/images/StarFilled.svg';
import { ReactComponent as More } from '../assets/images/More.svg';
import { ReactComponent as File } from '../assets/images/File.svg';
import { ReactComponent as Star } from '../assets/images/Star.svg';
import { ReactComponent as Money } from '../assets/images/Money.svg';
import { ReactComponent as Upload } from '../assets/images/Vector.svg';
import { ReactComponent as Percentage } from '../assets/images/Percentage.svg';
import { ReactComponent as NotFound } from '../assets/images/NotFound.svg';
import { ReactComponent as Search } from '../assets/images/Search.svg';
import { ReactComponent as Bell } from '../assets/images/Bell.svg';
import { ReactComponent as User } from '../assets/images/User.svg';
import { ReactComponent as Mail } from '../assets/images/mail.svg';
import { ReactComponent as HelpCenterIcon } from '../assets/images/HelpCenterIcon.svg';
import { ReactComponent as BannerLeft } from '../assets/images/BannerLeft.svg';
import { ReactComponent as BannerRight } from '../assets/images/BannerRight.svg';
import { ReactComponent as Spark } from '../assets/images/spark.svg';
import { ReactComponent as Article } from '../assets/images/Article.svg';

export {
  NavIconDashboard,
  NavIconInvoicing,
  NavIconReporting,
  NavIconMatters,
  NavIconDocuments,
  NavIconPeople,
  NavIconKnowledgeBase,
  AdherenceReminder,
  WalmartSpark,
  ChecklistTask,
  Link,
  Send,
  GlassSearch,
  CopyLink,
  Info,
  Folder,
  StarFilled,
  More,
  File,
  Star,
  Money,
  Upload,
  Percentage,
  NotFound,
  Search,
  Bell,
  User,
  Mail,
  HelpCenterIcon,
  BannerLeft,
  BannerRight,
  Spark,
  Article
};
